import { adminAreaService } from "../adminarea.service";
import { adminAreaConstants } from "./adminarea.constants";
import { alertActions } from "../../../_services/store/alert.actions";
import { countToolReducerActions } from "../../../_services/store";
import { reloadUserData } from "../../../user/services/store/authentication.actions";

export const adminAreaActions = {
    getAllOrganizations,
    getAllSelectableOrganizations,
    getOrganization,
    getReducedOrganizationForParallelTesting,
    setEditOrganization,
    setInitialAdminAreaStateForNewOrganization,
    discardChanges,
    getOrganizationsWithBillingEnabled,
    loadSimpleOrganizations,
    loadNextOrganizations,
    deleteOrganization,
    getAllUsers,
    getUsersByFilter,
    getUser,
    deleteUser,
    updateOrganization,
    updateUser,
    revokeLastPasswordChange,
    createNewResetPasswordLink,

    validateOrRefreshShopifyWebhooks,
    configurationCatchupStart,
    reprocessOrderData,
    recreateAllDocuments,
    triggerDownloadForAllDocuments,
    setInTestMode,
    triggerHealthReport,
    clearFilterProperties,
    resetToRegularOrganization,

    toggleOrderImportModal,
    importOrder,

    chargeOrganizations,
    clearBillingData,

    clearBMFData,

    getThreadDump,
    stopThread,
    getUserLoginStatistics,

    getAmazonPayoutFees,
    createAmazonPayoutFee,
    editAmazonPayoutFee,
    deleteAmazonPayoutFee,

    getAppStoreOrganizations,
    getAllApplications,
    setFilterProperties,
    setUserFilterProperties,
    clearDeletionErrorMessages,
    clearErrorMessage,
    cleanupOrderImport,

    clearStateOnLogin,
    saveGlobalSettings,
    getGlobalSettings,

    // ====== COUNT NAVIGATION FOR ORGANIZATION ADMIN ======
    toggleShopifyBasicCountModalForOrganization,
    toggleShopifyAdvancedCountModalForOrganization,
    toggleWooCommerceBasicCountModalForOrganization,
    toggleWooCommerceAdvancedCountModalForOrganization,
    toggleShopifyPaymentsCountModalForOrganization,
    toggleStripeChargesModalForOrganization,
    toggleTikTokShopCountModalForOrganization,
    toggleTikTokPaymentsCountModalForOrganization,
    toggleChargebeeOrganizationModal,
    toggleStripeBillingOrganizationModal,

    // Some leftovers of the count tool. I need to examine this to decide whether this belongs to the count module (@nburmei)
    getChargeBeeAutoSetupMessages,
    toggleShowAutoSetupModal,
    setAuditedOrganization,
    getAuditChanges,
    getOrganizationAndUsersAuditChanges,
    setParallelTestsOrganization,
    getParallelTestsDataForOrganization,
    getParallelTestsData,
    executeParallelTestForClientAndIntegration,

    toggleBugReportModal,
    createBugReport,
    getActiveMilestones,
    getProjectLabels,
};

console.log(adminAreaConstants.GET_ALL_SELECTABLE_ORGANIZATIONS_REQUEST);

function getAllOrganizations(filterProperties) {
    return (dispatch) => {
        dispatch(request(filterProperties));

        return adminAreaService.getAllOrganizations(filterProperties).then(
            (organizations) => {
                dispatch(success(organizations));
                return organizations;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request(filterProperties) {
        return {
            type: adminAreaConstants.GET_ALL_ORGANIZATIONS_REQUEST,
            filterProperties,
        };
    }

    function success(result) {
        return { type: adminAreaConstants.GET_ALL_ORGANIZATIONS_SUCCESS, result };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.GET_ALL_ORGANIZATIONS_FAILURE,
            errorMessage,
        };
    }
}

function getAllSelectableOrganizations() {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.getAllSelectableOrganizations().then(
            (organizations) => {
                dispatch(success(organizations));
                return organizations;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request(filterProperties) {
        return {
            type: adminAreaConstants.GET_ALL_SELECTABLE_ORGANIZATIONS_REQUEST,
            filterProperties,
        };
    }

    function success(result) {
        return {
            type: adminAreaConstants.GET_ALL_SELECTABLE_ORGANIZATIONS_SUCCESS,
            result,
        };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.GET_ALL_SELECTABLE_ORGANIZATIONS_FAILURE,
            errorMessage,
        };
    }
}

function getUsersByFilter(userFilterProperties) {
    return (dispatch) => {
        dispatch(request(userFilterProperties));

        return adminAreaService.getUserByFilter(userFilterProperties).then(
            (users) => {
                dispatch(success(users));
                return users;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request(userFilterProperties) {
        return {
            type: adminAreaConstants.GET_ADMIN_AREA_USER_BY_FILTER_REQUEST,
            userFilterProperties,
        };
    }

    function success(result) {
        return {
            type: adminAreaConstants.GET_ADMIN_AREA_USER_BY_FILTER_SUCCESS,
            result,
        };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.GET_ADMIN_AREA_USER_BY_FILTER_FAILURE,
            errorMessage,
        };
    }
}

function getOrganization(uuid) {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.getOrganization(uuid).then(
            (organization) => {
                dispatch(success(organization));
                return organization;
            },
            (error) => {
                dispatch(failure(error));
                return Promise.reject(error);
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.GET_ADMIN_AREA_ORGANIZATION_REQUEST };
    }

    function success(organization) {
        return {
            type: adminAreaConstants.GET_ADMIN_AREA_ORGANIZATION_SUCCESS,
            organization,
        };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.GET_ADMIN_AREA_ORGANIZATION_FAILURE,
            errorMessage,
        };
    }
}

function setEditOrganization(organization) {
    return { type: adminAreaConstants.SET_ADMIN_AREA_EDIT_ORGANIZATION, organization };
}

function setInitialAdminAreaStateForNewOrganization(state) {
    return { type: adminAreaConstants.SET_INITIAL_ADMIN_AREA_STATE, state };
}

function discardChanges() {
    return { type: adminAreaConstants.RESET_EDIT_ORGANIZATION_TO_CONFIGURATION };
}

function loadSimpleOrganizations() {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.loadSimpleOrganizations().then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.LOAD_SIMPLE_ORGANIZATIONS_REQUEST };
    }

    function success(result) {
        return {
            type: adminAreaConstants.LOAD_SIMPLE_ORGANIZATIONS_SUCCESS,
            result,
        };
    }

    function failure(error) {
        return {
            type: adminAreaConstants.LOAD_SIMPLE_ORGANIZATIONS_FAILURE,
            error,
        };
    }
}

function clearFilterProperties() {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.CLEAR_FILTER_PROPERTIES });
    };
}

/* function getOrganizationsWithBillingEnabled() {
    return dispatch => {
        dispatch(request());
        return adminAreaService.getOrganizationsWithBillingEnabled()
            .then(
                configurations => {
                    dispatch(success(configurations));
                    return configurations;
                },
                error => {
                    dispatch(failure(error));
                    return error;
                }
            );
    };

    function request() { return { type: adminAreaConstants.GET_ORGANIZATIONS_WITH_BILLING_ENABLED_REQUEST } }
    function success(configurations) {
        return { type: adminAreaConstants.GET_ORGANIZATIONS_WITH_BILLING_ENABLED_SUCCESS, configurations }
    }
    function failure(errorMessage) { return { type: adminAreaConstants.GET_ORGANIZATIONS_WITH_BILLING_ENABLED_FAILURE, errorMessage } }
} */

function getOrganizationsWithBillingEnabled(filterProperties) {
    return (dispatch) => {
        dispatch(request(filterProperties));
        return adminAreaService.getOrganizationsWithBillingEnabled(filterProperties).then(
            (configurations) => {
                dispatch(success(configurations));
                return configurations;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request(filterProperties) {
        return {
            type: adminAreaConstants.GET_ORGANIZATIONS_WITH_BILLING_ENABLED_REQUEST,
            filterProperties,
        };
    }

    function success(configurations) {
        return {
            type: adminAreaConstants.GET_ORGANIZATIONS_WITH_BILLING_ENABLED_SUCCESS,
            configurations,
        };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.GET_ORGANIZATIONS_WITH_BILLING_ENABLED_FAILURE,
            errorMessage,
        };
    }
}

function deleteOrganization(uuid) {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.deleteOrganization(uuid).then(
            (organization) => {
                dispatch(success(organization));
                return organization;
            },
            (error) => {
                dispatch(failure(error));
                throw error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.DELETE_ADMIN_AREA_ORGANIZATION_REQUEST };
    }

    function success(organization) {
        return {
            type: adminAreaConstants.DELETE_ADMIN_AREA_ORGANIZATION_SUCCESS,
            organization,
        };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.DELETE_ADMIN_AREA_ORGANIZATION_FAILURE,
            errorMessage,
        };
    }
}

function updateOrganization(organization) {
    return (dispatch) => {
        dispatch(request(organization));

        return adminAreaService.updateOrganization(organization).then(
            (result) => {
                dispatch(success(result));
                if (result.response) {
                    dispatch(alertActions.generalErrorAndClear(result.errorMessage, 3000));
                } else {
                    dispatch(alertActions.generalSuccessAndClear("Daten wurden erfolgreich gespeichert", 3000));
                }
                dispatch(reloadUserData()); // AllowedApps might have changed
                return result;
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.generalErrorAndClear(error, 5000));
                return error;
            }
        );
    };

    function request(organization) {
        return {
            type: adminAreaConstants.UPDATE_ADMIN_AREA_ORGANIZATION_REQUEST,
            organization,
        };
    }

    function success(organization) {
        return {
            type: adminAreaConstants.UPDATE_ADMIN_AREA_ORGANIZATION_SUCCESS,
            organization,
        };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.UPDATE_ADMIN_AREA_ORGANIZATION_FAILURE,
            errorMessage,
        };
    }
}

function getAllUsers() {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.getAllUsers().then(
            (users) => {
                dispatch(success(users));
                return users;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.GET_ADMIN_AREA_USERS_REQUEST };
    }

    function success(users) {
        return { type: adminAreaConstants.GET_ADMIN_AREA_USERS_SUCCESS, users };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.GET_ADMIN_AREA_USERS_FAILURE,
            errorMessage,
        };
    }
}

function getUser(uuid) {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.getUser(uuid).then(
            (user) => {
                dispatch(success(user));
                return user;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.GET_ADMIN_AREA_USER_REQUEST };
    }

    function success(user) {
        return { type: adminAreaConstants.GET_ADMIN_AREA_USER_SUCCESS, user };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.GET_ADMIN_AREA_USER_FAILURE,
            errorMessage,
        };
    }
}

function deleteUser(uuid) {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.deleteUser(uuid).then(
            (user) => {
                dispatch(success(user));
                return user;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.DELETE_ADMIN_AREA_USER_REQUEST };
    }

    function success(user) {
        return { type: adminAreaConstants.DELETE_ADMIN_AREA_USER_SUCCESS, user };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.DELETE_ADMIN_AREA_USER_FAILURE,
            errorMessage,
        };
    }
}

function updateUser(user) {
    return (dispatch) => {
        dispatch(request(user));

        return adminAreaService.updateUser(user).then(
            (result) => {
                if (result.errorMessage && result.errorMessage.length > 0) {
                    dispatch(failure(result.errorMessage));
                } else {
                    dispatch(success(result));
                    dispatch(alertActions.generalSuccessAndClear("Daten wurden erfolgreich gespeichert", 3000));
                }
                return result;
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.generalErrorAndClear("Fehler beim Speichern", 2000));
                return error;
            }
        );
    };

    function request(user) {
        return { type: adminAreaConstants.UPDATE_ADMIN_AREA_USER_REQUEST, user };
    }

    function success(user) {
        return { type: adminAreaConstants.UPDATE_ADMIN_AREA_USER_SUCCESS, user };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.UPDATE_ADMIN_AREA_USER_FAILURE,
            errorMessage,
        };
    }
}

function revokeLastPasswordChange(userUUID) {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.revokeLastPasswordChange(userUUID).then(
            (result) => {
                if (result.errorMessage && result.errorMessage.length > 0) {
                    dispatch(failure(result.errorMessage));
                } else {
                    dispatch(success(result));
                    dispatch(
                        alertActions.generalSuccessAndClear("Letztes Passwort-Reset erfolgreich zurücksetzt", 3000)
                    );
                }
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.REVOKE_ADMIN_AREA_USER_LAST_PASSWORD_CHANGE_REQUEST };
    }

    function success(user) {
        return { type: adminAreaConstants.REVOKE_ADMIN_AREA_USER_LAST_PASSWORD_CHANGE_SUCCESS, user };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.REVOKE_ADMIN_AREA_USER_LAST_PASSWORD_CHANGE_FAILURE,
            errorMessage,
        };
    }
}

function createNewResetPasswordLink(userUUID) {
    return (dispatch) => {
        dispatch(request(userUUID));

        return adminAreaService.createNewResetPasswordLink(userUUID).then(
            (result) => {
                if (result.errorMessage && result.errorMessage.length > 0) {
                    dispatch(failure(result.errorMessage));
                } else {
                    dispatch(success(result));
                    dispatch(alertActions.generalSuccessAndClear("Neuer Passwortrücksetzlink wurde erzeugt", 3000));
                }
                return result;
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.generalErrorAndClear("Fehler bei der Neuenlinkerzeugung", 2000));
                return error;
            }
        );
    };

    function request(userUUID) {
        return {
            type: adminAreaConstants.CREATE_NEW_RESET_PASSWORD_LINK_REQUEST,
            userUUID,
        };
    }

    function success(user) {
        return {
            type: adminAreaConstants.CREATE_NEW_RESET_PASSWORD_LINK_SUCCESS,
            user,
        };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.CREATE_NEW_RESET_PASSWORD_LINK_FAILURE,
            errorMessage,
        };
    }
}

function chargeOrganizations(requestDto) {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.chargeOrganizations(requestDto).then(
            (result) => {
                dispatch(success(result ? result.successMessage : ""));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.CHARGE_ORGANIZATIONS_REQUEST };
    }

    function success(successMessage) {
        return { type: adminAreaConstants.CHARGE_ORGANIZATIONS_SUCCESS, successMessage };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.CHARGE_ORGANIZATIONS_FAILURE,
            errorMessage,
        };
    }
}

function clearBillingData() {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.CLEAR_BILLING_DATA });
    };
}

function getChargeBeeAutoSetupMessages(externalUUID) {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.getChargeBeeAutoSetupMessages(externalUUID).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return {
            type: adminAreaConstants.GET_CHARGEBEE_AUTOSETUP_MESSAGES_REQUEST,
        };
    }

    function success(result) {
        return {
            type: adminAreaConstants.GET_CHARGEBEE_AUTOSETUP_MESSAGES_SUCCESS,
            result,
        };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.GET_CHARGEBEE_AUTOSETUP_MESSAGES_FAILURE,
            errorMessage,
        };
    }
}

function clearBMFData() {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.CLEAR_BMF_DATA });
    };
}

function getAmazonPayoutFees() {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.getAmazonPayoutFees().then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.GET_AMAZON_PAYOUT_FEES_REQUEST };
    }

    function success(result) {
        return { type: adminAreaConstants.GET_AMAZON_PAYOUT_FEES_SUCCESS, result };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.GET_AMAZON_PAYOUT_FEES_FAILURE,
            errorMessage,
        };
    }
}

function createAmazonPayoutFee(requestDto) {
    return (dispatch) => {
        dispatch(request(requestDto));

        return adminAreaService.createAmazonPayoutFee(requestDto).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request(requestDto) {
        return {
            type: adminAreaConstants.CREATE_AMAZON_PAYOUT_FEE_REQUEST,
            request: requestDto,
        };
    }

    function success(result) {
        return {
            type: adminAreaConstants.CREATE_AMAZON_PAYOUT_FEE_SUCCESS,
            result,
        };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.CREATE_AMAZON_PAYOUT_FEE_FAILURE,
            errorMessage,
        };
    }
}

function editAmazonPayoutFee(requestDto) {
    return (dispatch) => {
        dispatch(request(requestDto));

        return adminAreaService.editAmazonPayoutFee(requestDto).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request(requestDto) {
        return {
            type: adminAreaConstants.EDIT_AMAZON_PAYOUT_FEE_REQUEST,
            request: requestDto,
        };
    }

    function success(result) {
        return { type: adminAreaConstants.EDIT_AMAZON_PAYOUT_FEE_SUCCESS, result };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.EDIT_AMAZON_PAYOUT_FEE_FAILURE,
            errorMessage,
        };
    }
}

function deleteAmazonPayoutFee(externalUUID) {
    return (dispatch) => {
        dispatch(request(externalUUID));

        return adminAreaService.deleteAmazonPayoutFee(externalUUID).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.DELETE_AMAZON_PAYOUT_FEE_REQUEST };
    }

    function success(result) {
        return {
            type: adminAreaConstants.DELETE_AMAZON_PAYOUT_FEE_SUCCESS,
            result,
        };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.DELETE_AMAZON_PAYOUT_FEE_FAILURE,
            errorMessage,
        };
    }
}

function getThreadDump() {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.getThreadDump().then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.GET_ADMIN_THREAD_DUMP_REQUEST };
    }

    function success(result) {
        return { type: adminAreaConstants.GET_ADMIN_THREAD_DUMP_SUCCESS, result };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.GET_ADMIN_THREAD_DUMP_FAILURE,
            errorMessage,
        };
    }
}

function stopThread(requestDto) {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.stopThread(requestDto).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                dispatch(alertActions.generalErrorAndClear(error, 3000));
                dispatch(getThreadDump());
                return error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.STOP_THREAD_DUMP_REQUEST };
    }

    function success(result) {
        return { type: adminAreaConstants.STOP_THREAD_DUMP_SUCCESS, result };
    }

    function failure(errorMessage) {
        return { type: adminAreaConstants.STOP_THREAD_DUMP_FAILURE, errorMessage };
    }
}

function getUserLoginStatistics() {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.getUserLoginStatistics().then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.GET_USER_LOGIN_STATISTICS_REQUEST };
    }

    function success(result) {
        return {
            type: adminAreaConstants.GET_USER_LOGIN_STATISTICS_SUCCESS,
            result,
        };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.GET_USER_LOGIN_STATISTICS_FAILURE,
            errorMessage,
        };
    }
}

function getAppStoreOrganizations(filterProperties) {
    return (dispatch) => {
        dispatch(request(filterProperties));

        return adminAreaService.getAppStoreOrganizations(filterProperties).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request(filterProperties) {
        return {
            type: adminAreaConstants.GET_APP_STORE_ORGANIZATIONS_REQUEST,
            filterProperties,
        };
    }

    function success(result) {
        return {
            type: adminAreaConstants.GET_APP_STORE_ORGANIZATIONS_SUCCESS,
            result,
        };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.GET_APP_STORE_ORGANIZATIONS_FAILURE,
            errorMessage,
        };
    }
}

function getAllApplications() {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.getAllApplications().then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.GET_ALL_APPLICATIONS_REQUEST };
    }

    function success(result) {
        return { type: adminAreaConstants.GET_ALL_APPLICATIONS_SUCCESS, result };
    }

    function failure(errorMessage) {
        return {
            type: adminAreaConstants.GET_ALL_APPLICATIONS_FAILURE,
            errorMessage,
        };
    }
}

function setFilterProperties(filterProperties) {
    return (dispatch) => {
        dispatch({
            type: adminAreaConstants.SET_FILTER_PROPERTIES,
            filterProperties,
        });
    };
}

function setUserFilterProperties(userFilterProperties) {
    return (dispatch) => {
        dispatch({
            type: adminAreaConstants.SET_USER_FILTER_PROPERTIES,
            userFilterProperties,
        });
    };
}

function toggleOrderImportModal() {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.TOGGLE_ORDER_IMPORT_MODAL });
    };
}

function toggleShowAutoSetupModal() {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.TOGGLE_SHOW_AUTO_SETUP_MODAL });
    };
}

function importOrder(shopDomain, orderName, configurationId) {
    return (dispatch) => {
        dispatch(request());
        return adminAreaService.importOrder(shopDomain, orderName, configurationId).then(
            (result) => {
                dispatch(success(result));
                setTimeout(() => {
                    dispatch(cleanUp());
                }, 3000);
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.ORDER_IMPORT_REQUEST };
    }

    function success(result) {
        return { type: adminAreaConstants.ORDER_IMPORT_SUCCESS, result };
    }

    function failure(error) {
        return { type: adminAreaConstants.ORDER_IMPORT_FAILURE, error };
    }

    function cleanUp() {
        return { type: adminAreaConstants.ORDER_IMPORT_CLEANUP };
    }
}

function cleanupOrderImport() {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.ORDER_IMPORT_CLEANUP });
    };
}

function clearDeletionErrorMessages() {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.CLEAR_DELETION_ERROR_MESSAGES });
    };
}

function clearErrorMessage() {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.CLEAR_ERROR_MESSAGE });
    };
}

function validateOrRefreshShopifyWebhooks(configurationId) {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.validateOrRefreshShopifyWebhooks(configurationId).then(
            (result) => {
                return dispatch(success({ configurationId, result }));
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function request() {
        return { type: adminAreaConstants.VALIDATE_OR_REFRESH_WEBHOOKS_REQUEST };
    }

    function success(result) {
        return {
            type: adminAreaConstants.VALIDATE_OR_REFRESH_WEBHOOKS_SUCCESS,
            result,
        };
    }

    function failure(error) {
        return {
            type: adminAreaConstants.VALIDATE_OR_REFRESH_WEBHOOKS_FAILURE,
            error,
        };
    }
}

function configurationCatchupStart(configurationId) {
    return (dispatch) => {
        dispatch(request());
        setTimeout(() => {
            dispatch(cleanUp());
        }, 5000);

        return adminAreaService.configurationCatchupStart(configurationId).then(
            (result) => {
                return dispatch(success(result));
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );

        function request() {
            return { type: adminAreaConstants.CONFIGURATION_CATCHUP_START_REQUEST };
        }

        function success(result) {
            return {
                type: adminAreaConstants.CONFIGURATION_CATCHUP_START_SUCCESS,
                result,
            };
        }

        function failure(error) {
            return {
                type: adminAreaConstants.CONFIGURATION_CATCHUP_START_FAILURE,
                error,
            };
        }

        function cleanUp() {
            return { type: adminAreaConstants.CONFIGURATION_CATCHUP_START_CLEANUP };
        }
    };
}

function reprocessOrderData(configurationId) {
    return (dispatch) => {
        dispatch(request());
        setTimeout(() => {
            dispatch(cleanUp());
        }, 5000);

        return adminAreaService.reprocessOrderData(configurationId).then(
            (result) => {
                return dispatch(success(result));
            },
            (error) => {
                return dispatch(failure(error));
            }
        );

        function request() {
            return { type: adminAreaConstants.RECREATE_EXISTING_DOCUMENTS_REQUEST };
        }

        function success(result) {
            return {
                type: adminAreaConstants.RECREATE_EXISTING_DOCUMENTS_SUCCESS,
                result,
            };
        }

        function failure(error) {
            return {
                type: adminAreaConstants.RECREATE_EXISTING_DOCUMENTS_FAILURE,
                error,
            };
        }

        function cleanUp() {
            return { type: adminAreaConstants.RECREATE_DOCUMENTS_CLEANUP };
        }
    };
}

function recreateAllDocuments(configurationId) {
    return (dispatch) => {
        dispatch(request());
        setTimeout(() => {
            dispatch(cleanUp());
        }, 5000);

        return adminAreaService.recreateAllDocuments(configurationId).then(
            (result) => {
                return dispatch(success(result));
            },
            (error) => {
                return dispatch(failure(error));
            }
        );

        function request() {
            return { type: adminAreaConstants.RECREATE_ALL_DOCUMENTS_REQUEST };
        }

        function success(result) {
            return {
                type: adminAreaConstants.RECREATE_ALL_DOCUMENTS_SUCCESS,
                result,
            };
        }

        function failure(error) {
            return { type: adminAreaConstants.RECREATE_ALL_DOCUMENTS_FAILURE, error };
        }

        function cleanUp() {
            return { type: adminAreaConstants.RECREATE_DOCUMENTS_CLEANUP };
        }
    };
}

function triggerDownloadForAllDocuments(configurationId) {
    return (dispatch) => {
        dispatch(request());
        setTimeout(() => {
            dispatch(cleanUp());
        }, 5000);

        return adminAreaService.triggerDownloadForAllDocuments(configurationId).then(
            (result) => {
                return dispatch(success(result));
            },
            (error) => {
                return dispatch(failure(error));
            }
        );

        function request() {
            return { type: adminAreaConstants.DOWNLOAD_ALL_DOCUMENTS_REQUEST };
        }

        function success(result) {
            return {
                type: adminAreaConstants.DOWNLOAD_ALL_DOCUMENTS_SUCCESS,
                result,
            };
        }

        function failure(error) {
            return { type: adminAreaConstants.DOWNLOAD_ALL_DOCUMENTS_FAILURE, error };
        }

        function cleanUp() {
            return { type: adminAreaConstants.RECREATE_DOCUMENTS_CLEANUP };
        }
    };
}

function setInTestMode(configurationId) {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.setInTestMode(configurationId).then(
            (result) => {
                return dispatch(success(result));
            },
            (error) => {
                return dispatch(failure(error));
            }
        );

        function request() {
            return { type: adminAreaConstants.SET_TEST_MODE_REQUEST };
        }

        function success(result) {
            return { type: adminAreaConstants.SET_TEST_MODE_SUCCESS, result };
        }

        function failure(error) {
            return { type: adminAreaConstants.SET_TEST_MODE_FAILURE, error };
        }
    };
}

function triggerHealthReport(configurationId) {
    return (dispatch) => {
        dispatch(request());
        setTimeout(() => {
            dispatch(cleanUp());
        }, 5000);

        return adminAreaService.triggerHealthReport(configurationId).then(
            (result) => {
                return dispatch(success(result));
            },
            (error) => {
                return dispatch(failure(error));
            }
        );

        function request() {
            return { type: adminAreaConstants.TRIGGER_HEALTH_REPORT_REQUEST };
        }

        function success(result) {
            return { type: adminAreaConstants.TRIGGER_HEALTH_REPORT_SUCCESS, result };
        }

        function failure(error) {
            return { type: adminAreaConstants.TRIGGER_HEALTH_REPORT_FAILURE, error };
        }

        function cleanUp() {
            return { type: adminAreaConstants.TRIGGER_HEALTH_REPORT_CLEANUP };
        }
    };
}

function loadNextOrganizations() {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.LOAD_NEXT_ORGANIZATIONS });
    };
}

function resetToRegularOrganization(organizationUUID) {
    return (dispatch) => {
        dispatch(request());

        return adminAreaService.resetToRegularOrganization(organizationUUID).then(
            (result) => {
                dispatch(adminAreaActions.getAppStoreOrganizations());
                return dispatch(success());
            },
            (error) => {
                return dispatch(failure(error));
            }
        );

        function request() {
            return { type: adminAreaConstants.RESET_TO_REGULAR_ORGANIZATION_REQUEST };
        }

        function success(result) {
            return {
                type: adminAreaConstants.RESET_TO_REGULAR_ORGANIZATION_SUCCESS,
                result,
            };
        }

        function failure(error) {
            return {
                type: adminAreaConstants.RESET_TO_REGULAR_ORGANIZATION_FAILURE,
                error,
            };
        }
    };
}

function clearStateOnLogin() {
    return (dispatch) => {
        dispatch({
            type: adminAreaConstants.CLEAR_STATE_ON_LOGIN,
        });
    };
}

function saveGlobalSettings(globalSettings) {
    return async (dispatch) => {
        dispatch({ type: adminAreaConstants.SAVE_GLOBAL_SETTINGS_REQUEST });
        try {
            const updatedGlobalSettings = await adminAreaService.saveGlobalSettings(globalSettings);
            dispatch({ type: adminAreaConstants.SAVE_GLOBAL_SETTINGS_SUCCESS, updatedGlobalSettings });
        } catch (error) {
            dispatch({ type: adminAreaConstants.SAVE_GLOBAL_SETTINGS_FAILURE, errorMessage: error.message });
        }
    };
}

function getGlobalSettings() {
    return async (dispatch) => {
        dispatch({ type: adminAreaConstants.GET_GLOBAL_SETTINGS_REQUEST });
        try {
            const globalSettings = await adminAreaService.getGlobalSettings();
            dispatch({ type: adminAreaConstants.GET_GLOBAL_SETTINGS_SUCCESS, globalSettings });
        } catch (error) {
            dispatch({ type: adminAreaConstants.GET_GLOBAL_SETTINGS_FAILURE, errorMessage: error.message });
        }
    };
}

// TODO: Exclude to OrganizationAdmin module (own actions, reducer, service; like the count & search modules)
// ====== COUNT NAVIGATION FOR ORGANIZATION ADMIN PAGE ======
function toggleShopifyAdvancedCountModalForOrganization(organizationUUID) {
    return (dispatch) => {
        dispatch(countToolReducerActions.clearCountData());
        dispatch({
            type: adminAreaConstants.TOGGLE_SHOPIFY_ADVANCED_COUNT_MODAL_FOR_ORGANIZATION,
            organizationUUID,
        });
    };
}

function toggleWooCommerceAdvancedCountModalForOrganization(organizationUUID) {
    return (dispatch) => {
        dispatch(countToolReducerActions.clearCountData());
        dispatch({
            type: adminAreaConstants.TOGGLE_WOO_COMMERCE_ORDERS_ADVANCED_MODAL_FOR_ORGANIZATION,
            organizationUUID,
        });
    };
}

function toggleShopifyPaymentsCountModalForOrganization(organizationUUID) {
    return (dispatch) => {
        dispatch({
            type: adminAreaConstants.TOGGLE_SHOPIFY_PAYMENTS_MODAL_FOR_ORGANIZATION,
            organizationUUID,
        });
    };
}

function toggleStripeChargesModalForOrganization(organizationUUID) {
    return (dispatch) => {
        dispatch({
            type: adminAreaConstants.TOGGLE_STRIPE_CHARGES_MODAL_FOR_ORGANIZATION,
            organizationUUID,
        });
    };
}

function toggleTikTokShopCountModalForOrganization(organizationUUID) {
    return (dispatch) => {
        dispatch({
            type: adminAreaConstants.TOGGLE_TIKTOK_SHOP_MODAL_FOR_ORGANIZATION,
            organizationUUID,
        });
    };
}

function toggleTikTokPaymentsCountModalForOrganization(organizationUUID) {
    return (dispatch) => {
        dispatch({
            type: adminAreaConstants.TOGGLE_TIKTOK_PAYMENTS_MODAL_FOR_ORGANIZATION,
            organizationUUID,
        });
    };
}

function toggleChargebeeOrganizationModal(organizationUUID) {
    return (dispatch) => {
        dispatch({
            type: adminAreaConstants.TOGGLE_CHARGEBEE_MODAL_FOR_ORGANIZATION,
            organizationUUID,
        });
    };
}

function toggleStripeBillingOrganizationModal(organizationUUID) {
    return (dispatch) => {
        dispatch({
            type: adminAreaConstants.TOGGLE_STRIPE_BILLING_MODAL_FOR_ORGANIZATION,
            organizationUUID,
        });
    };
}

function toggleWooCommerceBasicCountModalForOrganization(organizationUUID) {
    return (dispatch) => {
        dispatch({
            type: adminAreaConstants.TOGGLE_WOO_COMMERCE_ORDERS_MODAL_FOR_ORGANIZATION,
            organizationUUID,
        });
    };
}

function toggleShopifyBasicCountModalForOrganization(organizationUUID) {
    return (dispatch) => {
        dispatch({
            type: adminAreaConstants.TOGGLE_SHOPIFY_BASIC_COUNT_MODAL_FOR_ORGANIZATION,
            organizationUUID,
        });
    };
}

function setAuditedOrganization(organization) {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.SET_AUDITED_ORGANIZATION, organization });
    };
}

function getAuditChanges(organizationExternalUUID, lookBackDays) {
    return async (dispatch) => {
        dispatch({ type: adminAreaConstants.GET_AUDIT_CHANGES_REQUEST });
        try {
            const response = await adminAreaService.getAuditChanges(organizationExternalUUID, lookBackDays);
            dispatch({ type: adminAreaConstants.GET_AUDIT_CHANGES_SUCCESS, response });
        } catch (error) {
            dispatch({ type: adminAreaConstants.GET_AUDIT_CHANGES_FAILURE, errorMessage: error.message });
        }
    };
}

function getOrganizationAndUsersAuditChanges(organizationUUID, lookBackDays) {
    return async (dispatch) => {
        dispatch({ type: adminAreaConstants.GET_ORGANIZATION_AND_USERS_AUDIT_CHANGES_REQUEST });
        try {
            const response = await adminAreaService.getOrganizationAndUsersAuditChanges(organizationUUID, lookBackDays);
            dispatch({ type: adminAreaConstants.GET_ORGANIZATION_AND_USERS_AUDIT_CHANGES_SUCCESS, response });
        } catch (error) {
            dispatch({
                type: adminAreaConstants.GET_ORGANIZATION_AND_USERS_AUDIT_CHANGES_FAILURE,
                errorMessage: error.message,
            });
        }
    };
}

function setParallelTestsOrganization(organization) {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.SET_PARALLEL_TESTS_ORGANIZATION_REQUEST, organization });
    };
}

function getParallelTestsData() {
    return async (dispatch) => {
        dispatch({ type: adminAreaConstants.GET_PARALLEL_TESTS_DATA_REQUEST });
        try {
            const response = await adminAreaService.getParallelTestsData();
            dispatch({ type: adminAreaConstants.GET_PARALLEL_TESTS_DATA_SUCCESS, response });
        } catch (error) {
            dispatch({
                type: adminAreaConstants.GET_PARALLEL_TESTS_DATA_FAILURE,
                errorMessage: error.message,
            });
        }
    };
}

function getParallelTestsDataForOrganization(organizationExternalUUID) {
    return async (dispatch) => {
        dispatch({ type: adminAreaConstants.GET_PARALLEL_TESTS_DATA_REQUEST });
        try {
            const response = await adminAreaService.getParallelTestsDataForOrganization(organizationExternalUUID);
            dispatch({ type: adminAreaConstants.GET_PARALLEL_TESTS_DATA_SUCCESS, response });
        } catch (error) {
            dispatch({
                type: adminAreaConstants.GET_PARALLEL_TESTS_DATA_FAILURE,
                errorMessage: error.message,
            });
        }
    };
}

function executeParallelTestForClientAndIntegration(request) {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.EXECUTE_PARALLEL_TEST_FOR_CLIENT_AND_INTEGRATION_REQUEST });
        try {
            const response = adminAreaService.executeParallelTestForClientAndIntegration(request);
            dispatch({ type: adminAreaConstants.EXECUTE_PARALLEL_TEST_FOR_CLIENT_AND_INTEGRATION_SUCCESS, response });
        } catch (error) {
            dispatch({
                type: adminAreaConstants.EXECUTE_PARALLEL_TEST_FOR_CLIENT_AND_INTEGRATION_FAILURE,
                errorMessage: error.message,
            });
        }
    };
}

function getReducedOrganizationForParallelTesting(organizationUUID) {
    return async (dispatch) => {
        dispatch({ type: adminAreaConstants.GET_REDUCED_ORGANIZATION_FOR_TESTING_REQUEST });
        try {
            const result = await adminAreaService.getReducedOrganizationByExternalUUID(organizationUUID);
            dispatch({ type: adminAreaConstants.GET_REDUCED_ORGANIZATION_FOR_TESTING_SUCCESS, result });
        } catch (error) {
            dispatch({
                type: adminAreaConstants.GET_REDUCED_ORGANIZATION_FOR_TESTING_FAILURE,
                errorMessage: error.message,
            });
        }
    };
}

function toggleBugReportModal() {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.TOGGLE_BUG_REPORT_MODAL });
    };
}

function createBugReport(request) {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.CREATE_BUG_REPORT_REQUEST });

        return adminAreaService.createBugReport(request).then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function success(result) {
        return { type: adminAreaConstants.CREATE_BUG_REPORT_SUCCESS, result };
    }

    function failure(errorMessage) {
        return { type: adminAreaConstants.CREATE_BUG_REPORT_FAILURE, errorMessage };
    }
}

function getActiveMilestones() {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.GET_ACTIVE_MILESTONES_REQUEST });

        return adminAreaService.getActiveMilestones().then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function success(result) {
        return { type: adminAreaConstants.GET_ACTIVE_MILESTONES_SUCCESS, result };
    }

    function failure(errorMessage) {
        return { type: adminAreaConstants.GET_ACTIVE_MILESTONES_FAILURE, errorMessage };
    }
}

function getProjectLabels() {
    return (dispatch) => {
        dispatch({ type: adminAreaConstants.GET_PROJECT_LABELS_REQUEST });

        return adminAreaService.getProjectLabels().then(
            (result) => {
                dispatch(success(result));
                return result;
            },
            (error) => {
                dispatch(failure(error));
                return error;
            }
        );
    };

    function success(result) {
        return { type: adminAreaConstants.GET_PROJECT_LABELS_SUCCESS, result };
    }

    function failure(errorMessage) {
        return { type: adminAreaConstants.GET_PROJECT_LABELS_FAILURE, errorMessage };
    }
}
